import TweenLite from 'gsap/TweenLite'
import { Power4 } from 'gsap/EasePack'
import AppPage from '../../mixins/app-page'

import AppHomeFooter from '../app-home-footer'
import AppHomeMobile from '../app-home-mobile'
import AppHomeSlide from '../app-home-slide'
import AppHomeSlide0 from '../app-home-slide-0'
import AppHomeSlide1 from '../app-home-slide-1'
import AppHomeSlide2 from '../app-home-slide-2'
import AppHomeSlide3 from '../app-home-slide-3'
import AppHomeSlide4 from '../app-home-slide-4'
import AppHomeSlide5 from '../app-home-slide-5'
import AppSocialsLinks from '../app-socials-links'

import SliderExperience from '../../libs/experience/SliderExperience'

export default
{
    name: 'page-home',

    mixins: [
        AppPage
    ],

    components: {
        AppHomeFooter,
        AppHomeMobile,
        AppHomeSlide,
        AppHomeSlide0,
        AppHomeSlide1,
        AppHomeSlide2,
        AppHomeSlide3,
        AppHomeSlide4,
        AppHomeSlide5,
        AppSocialsLinks
    },

    data() {
        return {
            activeIndex: 0,
            theme: 'white',
            lastActiveIndex: null,
            activeLevel: 0,
            activeNbLevels: 0,
            headerWidth: 0,
            soundIsActive: true,
            soundHidden: false,
            pendingAction: {
                activeIndex: null,
                activeLevel: null,
                activeNbLevels: null
            },
            isAnimated: false
        }
    },

    watch: {
        activeIndex() {
            this.onActiveChange('index')
        },

        activeLevel() {
            this.onActiveChange('level')
        },
        headerWidth: 'onHeaderWidthChange',
        isAnimated: 'onIsAnimatedChange'
    },

    created() {
        this.PIXEL_STEP = 10

        this.NBSLIDE = 6

        // Mousewheel
        this._isWheeling = false
        this._isPointerDown = false
        this._pointerY = 0
        this._pointerStartY = 0
        //

        // Slides
        this.slides = [{
            name: 'Countdown',
            index: 0,
            nbLevels: 0,
            backToFirstLevel: false
        }, {
            name: 'Win tokens',
            index: 1,
            nbLevels: 0,
            backToFirstLevel: false
        }, {
            name: 'Spatial mapping',
            index: 2,
            nbLevels: 2,
            backToFirstLevel: true
        }, {
            name: 'Grading metrics',
            index: 3,
            nbLevels: 3,
            backToFirstLevel: false
        }, {
            name: 'Maps',
            index: 4,
            nbLevels: 3,
            backToFirstLevel: false
        }, {
            name: 'Time',
            index: 5,
            nbLevels: 0,
            backToFirstLevel: false
        }]

        this.eventHub.$on('window:resize', this.onResize)
        this.eventHub.$on('keyboard:keydown', this.onKeydown)
        this.eventHub.$on('page-home:changeActiveIndexTo', this.changeActiveIndexTo)
        this.eventHub.$on('page-home:onPrevSlide', this.onPrevSlide)
        this.eventHub.$on('page-home:onNextSlide', this.onNextSlide)

        const localStorageMuted = window.localStorage.getItem('muted')

        this.soundIsActive = !localStorageMuted
        this.eventHub.$emit('app-sound-manager:back-to-start', 'ambient')
        this.eventHub.$emit('app-sound-manager:play', 'ambient')
        
        // Force play on any click
        window.addEventListener('click', () => {
            this.eventHub.$emit('app-sound-manager:play', 'ambient')
        })
        
        if (this.soundIsActive) {
            this.eventHub.$emit('app-sound-manager:unmute', 'ambient')
        } else {
            this.eventHub.$emit('app-sound-manager:mute', 'ambient')
        }
    },

    mounted() {
        if (this.$route.params.slug) {
            const slugInt = parseInt(this.$route.params.slug, 10)

            if (isNaN(slugInt)) {
                this.$router.push(this.CONFIG.pages.home.path)
            } else if (slugInt >= this.NBSLIDE) {
                this.$router.push(this.CONFIG.pages.home.path)
            } else {
                this.changeActiveIndexTo(slugInt)
            }
        }

        if (document.querySelector('.js-nav-container')) {
            this.headerWidth = document.querySelector('.js-nav-container').offsetWidth
        } else {
            this.eventHub.$on('app-header:mounted', this.onHeaderMounted)
        }

        this.onResize()

        if (this.$root.width >= 770) {
            this.experience = new SliderExperience()
            this.experience.on('loadStart', () => {
                this.eventHub.$emit('app-loader:start-loading-asset')
            })
            this.experience.on('loadProgress', () => {
                this.eventHub.$emit('app-loader:end-loading-asset')
            })
            this.experience.renderer.domElement.classList.add('c-home-experience')

            this.experience.scenes.all.scan.on('prac-found', (foundsCount) => {
                this.eventHub.$emit('app-home-slide-1:update-prac-earned', foundsCount)
            })

            this.$el.appendChild(this.experience.renderer.domElement)
        }
        
        // Swipe
        this.setSwipe()
    },

    destroyed() {
        this.eventHub.$off('window:resize', this.onResize)
        this.eventHub.$off('keyboard:keydown', this.onKeydown)
        this.eventHub.$off('page-home:changeActiveIndexTo', this.changeActiveIndexTo)
        this.eventHub.$off('page-home:onPrevSlide', this.onPrevSlide)
        this.eventHub.$off('page-home:onNextSlide', this.onNextSlide)

        this.eventHub.$emit('app-sound-manager:mute', 'ambient')

        if (this.experience) {
            this.experience.dispose()
        }
    },

    methods: {
        onHeaderMounted() {
            const $navContainer = document.querySelector('.js-nav-container')
            
            if ($navContainer) {
                this.headerWidth = $navContainer.offsetWidth
            }
        },

        onActiveChange(type) {
            if (!this.isAnimated && this.experience) {
                this.$root.isFirstLoaded = false
                this.isAnimated = true

                setTimeout(() => {
                    this.isAnimated = false
                }, 1500)

                if (this.activeIndex === 0) {
                    this.$router.push(this.CONFIG.pages.home.path)
                } else {
                    this.$router.push(this.CONFIG.pages.homeSlide.path.replace(':slug', this.activeIndex < 10 ? `0${this.activeIndex}` : this.activeIndex))
                }

                // Film effect
                TweenLite.killTweensOf(this.experience.distortionShaderPass.uniforms.uFilmEffect)
                TweenLite.killTweensOf(this.experience.distortionShaderPass.uniforms.uOverlayEffect)
                if (this.activeIndex === 2) {
                    if (this.activeLevel === 1) {
                        TweenLite.to(this.experience.distortionShaderPass.uniforms.uFilmEffect, 0.5, { value: 0.3, delay: 0.5 })
                        TweenLite.to(this.experience.distortionShaderPass.uniforms.uOverlayEffect, 0.5, { value: 0.2, delay: 0.5 })
                    } else {
                        TweenLite.to(this.experience.distortionShaderPass.uniforms.uFilmEffect, 1, { value: 0, delay: 3.5, ease: Power4.easeInOut })
                        TweenLite.to(this.experience.distortionShaderPass.uniforms.uOverlayEffect, 0.5, { value: 0.4, delay: 0.5 })
                        TweenLite.to(this.experience.distortionShaderPass.uniforms.uOverlayEffect, 1, { value: 1, delay: 3.5 })
                    }
                } else {
                    TweenLite.to(this.experience.distortionShaderPass.uniforms.uFilmEffect, 0.5, { value: 0 })
                    TweenLite.to(this.experience.distortionShaderPass.uniforms.uOverlayEffect, 0.5, { value: 1 })
                }

                if (type === 'index') {
                    // Event
                    this.eventHub.$emit('page-home:onActiveIndexChange', this.activeIndex)

                    // Change slide
                    this.experience.goTo(this.activeIndex)

                    // Change level
                    if (this.experience.scenes.active.hasLevels) {
                        this.experience.scenes.active.goToLevel(this.activeLevel)
                    }
                    
                    // Sound
                    this.soundHidden = true
            
                    if (this.soundHiddenTimeout) {
                        window.clearTimeout(this.soundHiddenTimeout)
                        this.soundHiddenTimeout = null
                    }
                    
                    this.soundHiddenTimeout = window.setTimeout(() => {
                        switch (this.activeIndex) {
                        case 0:
                            this.theme = 'white'
                            break
                        case 1:
                            this.theme = 'black'
                            break
                        case 2:
                            this.theme = 'white'
                            break
                        case 3:
                            this.theme = 'white'
                            break
                        case 4:
                            this.theme = 'white'
                            break
                        case 5:
                            this.theme = 'white'
                            break
                        default:
                            break
                        }
                
                        this.soundHidden = false
                    }, 1400)
                } else if (type === 'level') {
                    // Event
                    this.eventHub.$emit('page-home:onActiveLevelChange', this.activeLevel)

                    // Change level
                    if (this.experience.scenes.active.hasLevels) {
                        this.experience.scenes.active.goToLevel(this.activeLevel)
                    }
                }
            }
        },

        onHeaderWidthChange() {
            if (this.experience) {
                this.experience.scenes.all.scan2.headerWidth = this.headerWidth + (this.$root.width / 12 * 2) - 20 /* $paddings["xs"] */
            }
        },

        onIsAnimatedChange() {
            // If there is a pending action
            if (!this.isAnimated && this.pendingAction.activeIndex !== null && this.pendingAction.activeLevel !== null && this.pendingAction.activeNbLevels !== null) {
                this.activeIndex = this.pendingAction.activeIndex
                this.activeLevel = this.pendingAction.activeLevel
                this.activeNbLevels = this.pendingAction.activeNbLevels
                
                this.pendingAction = {
                    activeIndex: null,
                    activeLevel: null,
                    activeNbLevels: null
                }
            }
        },

        onResize() {
            if (document.querySelector('.js-nav-container')) {
                this.headerWidth = document.querySelector('.js-nav-container').offsetWidth
            }

            // Remove experience on mobile
            // if ((this.$root.isTouch || this.$root.width < 770) && this.experience) {
            //     this.experience.renderer.domElement.classList.remove('c-home-experience')
            //     this.experience = null
            // } else if (!this.experience) {
            //     this.experience = new SliderExperience()
            //     this.experience.renderer.domElement.classList.add('c-home-experience')
            //
            //     this.experience.scenes.all.scan.on('prac-found', (foundsCount) => {
            //         this.eventHub.$emit('app-home-slide-1:update-prac-earned', foundsCount)
            //     })
            // }
        },

        onKeydown(event) {
            if (event.keyCode === 39 && event.key === 'ArrowRight') {
                this.onNextSlide()
            } else if (event.keyCode === 37 && event.key === 'ArrowLeft') {
                this.onPrevSlide()
            }
        },

        onPrevSlide() {
            this.changeActiveIndexTo(this.activeIndex, 'previous')
        },

        onNextSlide() {
            this.changeActiveIndexTo(this.activeIndex, 'next')
        },

        changeActiveIndexTo(index, direction) {
            this.slides.forEach(slide => {
                if (index === slide.index) {
                    if (direction === 'previous') {
                        // If we use scroll / arrows
                        if (slide.nbLevels > 0) {
                            // Slide has multiple level
                            if (this.activeLevel > 1) {
                                // Can change level
                                if (this.isAnimated) {
                                    // If component is animated
                                    // Store next action
                                    this.pendingAction.activeIndex = slide.index

                                    this.pendingAction.activeLevel = this.activeLevel - 1
                                    this.pendingAction.activeNbLevels = slide.nbLevels
                                } else {
                                    this.activeIndex = slide.index

                                    this.activeLevel -= 1
                                    this.activeNbLevels = slide.nbLevels
                                }
                            } else {
                                // Level reaches limit
                                const prevSlide = this.slides[slide.index - 1]
                                if (prevSlide) {
                                    if (this.isAnimated) {
                                        // If component is animated
                                        // Store next action
                                        this.pendingAction.activeIndex = prevSlide.index

                                        if (prevSlide.nbLevels > 0) {
                                            if (prevSlide.backToFirstLevel) {
                                                // If prevSlide has multiple level, go to the last
                                                this.pendingAction.activeLevel = 1
                                            } else {
                                                // If we don't want to go to the first level
                                                this.pendingAction.activeLevel = prevSlide.nbLevels
                                            }
                                        } else {
                                            // If prevSlide hasn't multiple level, go to 0
                                            this.pendingAction.activeLevel = 0
                                        }

                                        this.pendingAction.activeNbLevels = prevSlide.nbLevels
                                    } else {
                                        this.lastActiveIndex = this.activeIndex
                                        this.activeIndex = prevSlide.index

                                        if (prevSlide.nbLevels > 0) {
                                            if (prevSlide.backToFirstLevel) {
                                                // If prevSlide has multiple level, go to the last
                                                this.activeLevel = 1
                                            } else {
                                                // If we don't want to go to the first level
                                                this.activeLevel = prevSlide.nbLevels
                                            }
                                        } else {
                                            // If prevSlide hasn't multiple level, go to 0
                                            this.activeLevel = 0
                                        }

                                        this.activeNbLevels = prevSlide.nbLevels
                                    }
                                }
                            }
                        } else {
                            // Slide hasn't multiple level
                            const prevSlide = this.slides[slide.index - 1]
                            if (prevSlide) {
                                if (this.isAnimated) {
                                    // If component is animated
                                    // Store next action
                                    this.pendingAction.activeIndex = prevSlide.index

                                    if (prevSlide.nbLevels > 0) {
                                        if (prevSlide.backToFirstLevel) {
                                            // If prevSlide has multiple level, go to the last
                                            this.pendingAction.activeLevel = 1
                                        } else {
                                            // If we don't want to go to the first level
                                            this.pendingAction.activeLevel = prevSlide.nbLevels
                                        }
                                    } else {
                                        // If prevSlide hasn't multiple level, go to 0
                                        this.pendingAction.activeLevel = 0
                                    }

                                    this.pendingAction.activeNbLevels = prevSlide.nbLevels
                                } else {
                                    this.lastActiveIndex = this.activeIndex
                                    this.activeIndex = prevSlide.index

                                    if (prevSlide.nbLevels > 0) {
                                        if (prevSlide.backToFirstLevel) {
                                            // If prevSlide has multiple level, go to the last
                                            this.activeLevel = 1
                                        } else {
                                            // If we don't want to go to the first level
                                            this.activeLevel = prevSlide.nbLevels
                                        }
                                    } else {
                                        // If prevSlide hasn't multiple level, go to 0
                                        this.activeLevel = 0
                                    }

                                    this.activeNbLevels = prevSlide.nbLevels
                                }
                            }
                        }
                    } else if (direction === 'next') {
                        // If we use scroll / arrows
                        if (slide.nbLevels > 0) {
                            // Slide has multiple level
                            if (this.activeLevel < slide.nbLevels) {
                                // Can change level
                                if (this.isAnimated) {
                                    // If component is animated
                                    // Store next action
                                    this.pendingAction.activeIndex = slide.index

                                    this.pendingAction.activeLevel = this.activeLevel + 1
                                    this.pendingAction.activeNbLevels = slide.nbLevels
                                } else {
                                    this.activeLevel += 1
                                }
                            } else {
                                // Level reaches limit
                                const nextSlide = this.slides[slide.index + 1]
                                if (nextSlide) {
                                    if (this.isAnimated) {
                                        // If component is animated
                                        // Store next action
                                        this.pendingAction.activeIndex = nextSlide.index

                                        if (nextSlide.nbLevels > 0) {
                                            // If nextSlide has multiple level, go to the 1st
                                            this.pendingAction.activeLevel = 1
                                        } else {
                                            // If nextSlide hasn't multiple level, go to 0
                                            this.pendingAction.activeLevel = 0
                                        }

                                        this.pendingAction.activeNbLevels = nextSlide.nbLevels
                                    } else {
                                        this.lastActiveIndex = this.activeIndex
                                        this.activeIndex = nextSlide.index

                                        if (nextSlide.nbLevels > 0) {
                                            // If nextSlide has multiple level, go to the 1st
                                            this.activeLevel = 1
                                        } else {
                                            // If nextSlide hasn't multiple level, go to 0
                                            this.activeLevel = 0
                                        }

                                        this.activeNbLevels = nextSlide.nbLevels
                                    }
                                }
                            }
                        } else {
                            // Slide hasn't multiple level
                            const nextSlide = this.slides[slide.index + 1]
                            if (nextSlide) {
                                if (this.isAnimated) {
                                    // If component is animated
                                    // Store next action
                                    this.pendingAction.activeIndex = nextSlide.index

                                    if (nextSlide.nbLevels > 0) {
                                        // If nextSlide has multiple level, go to the 1st
                                        this.pendingAction.activeLevel = 1
                                    } else {
                                        // If nextSlide hasn't multiple level, go to 0
                                        this.pendingAction.activeLevel = 0
                                    }

                                    this.pendingAction.activeNbLevels = nextSlide.nbLevels
                                } else {
                                    this.lastActiveIndex = this.activeIndex
                                    this.activeIndex = nextSlide.index

                                    if (nextSlide.nbLevels > 0) {
                                        // If nextSlide has multiple level, go to the 1st
                                        this.activeLevel = 1
                                    } else {
                                        // If nextSlide hasn't multiple level, go to 0
                                        this.activeLevel = 0
                                    }

                                    this.activeNbLevels = nextSlide.nbLevels
                                }
                            }
                        }
                    } else if (!direction) {
                        // If we use footer items
                        if (index >= 0 && index < this.slides.length) {
                            if (this.isAnimated) {
                                // If component is animated
                                // Store next action
                                this.pendingAction.activeIndex = slide.index

                                if (slide.nbLevels > 0) {
                                    // If slide has multiple level, go to the 1st
                                    this.pendingAction.activeLevel = 1
                                } else {
                                    // If slide hasn't multiple level, go to 0
                                    this.pendingAction.activeLevel = 0
                                }
                                this.pendingAction.activeNbLevels = slide.nbLevels
                            } else {
                                this.lastActiveIndex = this.activeIndex
                                this.activeIndex = slide.index

                                if (slide.nbLevels > 0) {
                                    // If slide has multiple level, go to the 1st
                                    this.activeLevel = 1
                                } else {
                                    // If slide hasn't multiple level, go to 0
                                    this.activeLevel = 0
                                }
                                this.activeNbLevels = slide.nbLevels
                            }
                        }
                    }
                }
            })
        },

        onMouseWheel(event) {
            if (this.$root.routingStep !== 0) return

            event.preventDefault()
            event.stopPropagation()

            clearTimeout(this.wheelTimer)
            this.wheelTimer = setTimeout(() => {
                this._isWheeling = false
            }, 100)


            if (Math.abs(-this.normalizeWheel(event).pixelY) < 20) {
                clearTimeout(this.wheelTimer)
                this._isWheeling = false
            }

            if (this._isWheeling
                || Math.abs(-this.normalizeWheel(event).pixelY) < 20
                || Date.now() - this._lastWheelTime < 750) {
                return
            }

            this._lastWheelTime = Date.now()

            this._wheelEndTimer = setTimeout(() => {
                clearTimeout(this.wheelTimer)
                this._isWheeling = false
            }, 1000)

            this._isWheeling = true

            this._isScrollFromWheel = true

            const normalizeWheel = this.normalizeWheel(event)
            const wheelDeltaY = -normalizeWheel.pixelY
            const delta = wheelDeltaY

            if (delta < 0) {
                this.onNextSlide()
            } else if (delta > 0) {
                this.onPrevSlide()
            }
        },

        normalizeWheel(event) {
            this._sX = 0
            this._sY = 0 // spinX, spinY

            this._pX = 0
            this._pY = 0 // pixelX, pixelY

            // Legacy
            if ('detail' in event) { this._sY = event.detail }
            if ('wheelDelta' in event) { this._sY = -event.wheelDelta / 120 }
            if ('wheelDeltaY' in event) { this._sY = -event.wheelDeltaY / 120 }
            if ('wheelDeltaX' in event) { this._sX = -event.wheelDeltaX / 120 }

            // side scrolling on FF with DOMMouseScroll
            if ('axis' in event && event.axis === event.HORIZONTAL_AXIS) {
                this._sX = this._sY
                this._sY = 0
            }

            this._pX = this._sX * this.PIXEL_STEP
            this._pY = this._sY * this.PIXEL_STEP

            if ('deltaY' in event) { this._pY = event.deltaY }
            if ('deltaX' in event) { this._pX = event.deltaX }

            if ((this._pX || this._pY) && event.deltaMode) {
                if (event.deltaMode == 1) {          // delta in LINE units
                    this._pX *= this.LINE_HEIGHT
                    this._pY *= this.LINE_HEIGHT
                } else {                             // delta in PAGE units
                    this._pX *= this.PAGE_HEIGHT
                    this._pY *= this.PAGE_HEIGHT
                }
            }

            // Fall-back if spin cannot be determined
            if (this._pX && !this._sX) { this._sX = (this._pX < 1) ? -1 : 1 }
            if (this._pY && !this._sY) { this._sY = (this._pY < 1) ? -1 : 1 }

            return { spinX: this._sX,
                spinY: this._sY,
                pixelX: this._pX,
                pixelY: this._pY }
        },
        
        onSoundClick() {
            if (this.soundIsActive) {
                this.soundIsActive = false
                
                window.localStorage.setItem('muted', '1')
                
                this.eventHub.$emit('app-sound-manager:mute', 'ambient')
            } else {
                this.soundIsActive = true
                
                window.localStorage.removeItem('muted')
                
                this.eventHub.$emit('app-sound-manager:unmute', 'ambient')
            }
        },
        
        setSwipe() {
            this.swipe = {}
            this.swipe.minDistance = 20
            this.swipe.startX = 0
            this.swipe.startY = 0
            
            // Generic methods
            this.swipe.start = (_x, _y) => {
                this.swipe.startX = _x
                this.swipe.startY = _y
            }
            
            this.swipe.end = (_x, _y) => {
                const xDistance = this.swipe.startX - _x
                const yDistance = this.swipe.startY - _y

                // Horizontal swipe
                if (Math.abs(xDistance) > Math.abs(yDistance)) {
                    // To left / Go right
                    if (xDistance > this.swipe.minDistance) {
                        this.onNextSlide()
                        
                    // To right / Go left
                    } else if (xDistance < -this.swipe.minDistance) {
                        this.onPrevSlide()
                    }
                }
            }

            // Touch methods
            this.swipe.touchStartCallback = (_event) => {
                this.swipe.start(_event.changedTouches[0].screenX, _event.changedTouches[0].screenY)

                document.body.addEventListener('touchend', this.swipe.touchEndCallback)
            }

            this.swipe.touchEndCallback = (_event) => {
                this.swipe.end(_event.changedTouches[0].screenX, _event.changedTouches[0].screenY)

                document.body.removeEventListener('touchend', this.swipe.touchEndCallback)
            }

            document.body.addEventListener('touchstart', this.swipe.touchStartCallback)

            // Mouse methods
            this.swipe.mouseDownCallback = (_event) => {
                this.swipe.start(_event.clientX, _event.clientY)
                
                this.$el.classList.add('is-grabbing')

                document.body.addEventListener('mouseup', this.swipe.mouseUpCallback)
            }

            this.swipe.mouseUpCallback = (_event) => {
                this.swipe.end(_event.clientX, _event.clientY)

                this.$el.classList.remove('is-grabbing')

                document.body.removeEventListener('mouseup', this.swipe.mouseUpCallback)
            }

            document.body.addEventListener('mousedown', this.swipe.mouseDownCallback)
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/page-home/script.js